module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/01-7652bf4c5f3543ac42850ec17ae96194.jpeg";